// File: /pages/About/FAQs.js
/* eslint-disable react/jsx-filename-extension */
import Discuss from 'parts/Discuss';
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/jsx-filename-extension */
import React, { useState } from "react";
import Modal from "components/Modal";

const FAQ_DATA = [
  {
    id: "managed-it",
    title: "Understanding Managed IT Services",
    items: [
      "What Are Managed IT Services?",
      "Benefits of Managed IT for Businesses",
      "Difference Between Managed IT Services and Break-Fix",
      "How to Choose the Right MSP",
      "In-House IT vs. Outsourced IT",
    ],
  },
  {
    id: "cybersecurity",
    title: "Cybersecurity and Data Protection",
    items: [
      "Cybersecurity Threats Facing Small and Medium Businesses",
      "How Managed IT Services Enhance Cybersecurity",
      "Importance of Data Backup and Disaster Recovery",
      "Employee Cybersecurity Training",
      "Compliance and Regulatory Support",
    ],
  },
  {
    id: "cloud",
    title: "Cloud Services and Remote Work Solutions",
    items: [
      "What Are Cloud Services?",
      "Benefits of Cloud Storage and Collaboration Tools",
      "Security in the Cloud",
      "Transitioning to Cloud Services",
      "Remote Work IT Support",
    ],
  },
  {
    id: "support",
    title: "IT Support and Helpdesk Services",
    items: [
      "24/7 IT Support",
      "Helpdesk Support for Common IT Issues",
      "Onsite vs. Remote IT Support",
      "Proactive Monitoring and Maintenance",
      "Service Level Agreements (SLAs)",
    ],
  },
  {
    id: "network",
    title: "Network Management and Optimization",
    items: [
      "What Is Network Management?",
      "Benefits of Proactive Network Monitoring",
      "Optimizing Network Performance",
      "Wi-Fi and Connectivity Solutions",
      "Managing Network Security",
    ],
  },
  {
    id: "cost",
    title: "Cost Efficiency and Budget Management in IT",
    items: [
      "How Managed IT Services Help Control Costs",
      "Reducing Downtime with Proactive IT Management",
      "Optimizing Technology Investments",
      "Scaling IT Services as Your Business Grows",
      "Achieving Cost Transparency with Managed IT",
    ],
  },
];

export default function FAQs() {
  const [activeQuestion, setActiveQuestion] = useState(null);

  return (
    <>

      <section className="container mx-auto px-6 py-20 max-w-7xl">
        <h1 className="text-5xl font-bold text-theme-blue text-center mb-16">
          Frequently Asked Questions
        </h1>

        {/* GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-16">
          {FAQ_DATA.map((section) => (
            <div key={section.id}>
              <h2 className="text-xl font-semibold mb-6 text-gray-900">
                {section.title}
              </h2>

              <ul className="divide-y">
                {section.items.map((question) => (
                  <li key={question}>
                    <button
                      type="button"
                      onClick={() => setActiveQuestion(question)}
                      className="w-full flex justify-between items-center py-4 text-left text-theme-green hover:underline font-medium"
                    >
                      <span>{question}</span>
                      <span className="text-gray-400 text-xl">›</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* MODAL */}
      <Modal
        open={Boolean(activeQuestion)}
        onClose={() => setActiveQuestion(null)}
        title={activeQuestion || ""}
      >
        <p className="text-gray-600 leading-relaxed">
          This is where the detailed answer for
          <strong> {activeQuestion}</strong> will go.
          <br />
          <br />
          You can later replace this with real content or fetch it dynamically
          from a CMS or API.
        </p>
      </Modal>

      <Discuss />
    </>
  );
}
